import axios from "axios";
// import home from "../../home/home";
import {
  calculateTimeDifferenceTwoDates,
  geDataFormat,
  logOut,
} from "../../../common/utils";
// import user from "../../../common/mookup/mokup_ListaUser";
import jwt_decode from "jwt-decode";

export default class manageProfileService {
  //   getDataChart(onSuccess) {
  //     var dataChart = [
  //       {
  //         name: "13/12/21",
  //         uv: 150,
  //       },
  //       {
  //         name: "14/12/21",
  //         uv: 110,
  //       },
  //       {
  //         name: "15/12/21",
  //         uv: 170,
  //       },
  //       {
  //         name: "16/12/21",
  //         uv: 180,
  //       },
  //       {
  //         name: "17/12/21",
  //         uv: 90,
  //       },
  //       {
  //         name: "18/12/21",
  //         uv: 0,
  //       },
  //       {
  //         name: "19/12/21",
  //         uv: 0,
  //       },
  //     ];
  //     onSuccess(dataChart);
  //   }

  getDataTableSanzioni(stato, onSuccess) {
    var headerDataTableSanzione = [
      { label: "Nome", field: "nome", width: 270 },
      // {
      //   label: "id_anagrafica_operatore",
      //   field: "id_anagrafica_operatore",
      //   width: 100,
      //   attributes: {
      //     "aria-controls": "DataTable",
      //     "aria-label": "Name",
      //     "display" :"none",
      //   },
      // },
      { label: "Cognome", field: "cognome", width: 270 },
      { label: "C.F", field: "cf", width: 270 },
      { label: "Numero di Sanzioni", field: "nSanz", width: 270 },
    ];
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios.get(host + "/api/v1/recidivi/find/", configHeaders).then(
      function (result) {
        if(result.status === 401){
          logOut();
        }
        let dataTableUtenti = [];
        // console.log(result.data)
        result.data.map((result, index) => {
          dataTableUtenti = [
            ...dataTableUtenti,
            {
              nome: result.nome,
              cognome: result.cognome,
              cf: result.cf,
              nSanz: result.nSanz,
              listaDiDettaglioSanzioni: [
                result.listaDiDettaglioSanzioni.map((val) => {
                  return {
                    numSanzione: val.numSanzione,
                    dataEmissione: val.dataEmissione,
                    statoSanzione: val.statoSanzione,
                    idSanzione: val.idSanzione,
                  };
                }),
              ],
            },
          ];
          // result.listaDiDettaglioSanzioni.map((val) => {
          //   dataTableUtenti.listaDiDettaglioSanzioni = [
          //     ...dataTableUtenti.listaDiDettaglioSanzioni,
          //     {
          //       numSanzione: val.numSanzione,
          //       dataEmissione: val.dataEmissione,
          //       statoSanzione: val.statoSanzione,
          //       idSanzione: val.idSanzione,
          //     },
          //   ];
          // });
        });
        // console.log(dataTableUtenti);
        onSuccess(headerDataTableSanzione, dataTableUtenti);
      },
      function (error) {
        if(error.response.status === 401){
          logOut();
        }
        console.log("errore ricerca composizione " + error);
        // onSuccess(headerDataTableSanzione, user);
      }
    );
  }

  saveUserIsert(user, onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    let clienti = {
      idCliente: decoded.ID,
      attivo: 1,
      nome: "ANM",
      codiceFiscale: "06937950639",
      indirizzo: "Via G. Marino n.1, 80125 Napoli",
      codiceUnivocoFatturazione: "",
      email: "anmspa@pec.anm.it",
    };
    user.clienti = clienti;
    // console.log(user);
    axios.post(host + "/api/v1/user/save", user, configHeaders).then(
      function (result) {
        // console.log(result.data);
        if(result.status === 401){
          logOut();
        }
        onSuccess(result);
      },
      function (error) {
        if(error.response.status === 401){
          logOut();
        }
        console.log("errore ricerca composizione " + error);
        // onSuccess(headerDataTableSanzione, user);
      }
    );
  }
}
